import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
export const useAlerts = (AlertIcon) => {
    const { sizeUnit } = useTheme();
    const style = useMemo(() => ({
        width: sizeUnit * 11,
        paddingTop: 0,
        paddingBottom: 0
    }), [sizeUnit]);
    return (hooks) => {
        hooks.visibleColumnsDeps.push((deps, { instance }) => {
            if (AlertIcon) {
                return [...deps, instance.data];
            }
            return deps;
        });
        hooks.visibleColumns.push((columns, { instance }) => {
            var _a;
            // todo: the page should be considered here, not all the data. But instance.page doesnot exist here
            if (AlertIcon && ((_a = instance.data) === null || _a === void 0 ? void 0 : _a.some((row) => { var _a; return (_a = row.alerts) === null || _a === void 0 ? void 0 : _a.count; }))) {
                return [
                    {
                        id: 'alerts',
                        accessor: 'alerts',
                        style,
                        isVirtualColumn: true,
                        disableFilters: true,
                        disableResizing: true,
                        disableSortBy: true,
                        disableGroupBy: true,
                        className: 'invent-table-alerts',
                        Header: () => null,
                        Cell: ({ cell }) => {
                            const row = cell.row;
                            return !row.original.alerts ? null : React.createElement(AlertIcon, { alerts: row.original.alerts });
                        }
                    },
                    ...columns
                ];
            }
            return columns;
        });
    };
};
